import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import ExportTemplatesSelect from '../component/ExportTemplatesSelect'

const GeneralSection = () => {
  return (
    <Grid direction="column" gap={0.5}>
      <Col>
        <FormItem label="Selecione o template*" field="template" Input={ExportTemplatesSelect} />
      </Col>
    </Grid>
  )
}

export default GeneralSection
